import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Chip } from "shared/ui/chip/Chip"

import { TeamRole } from "entities/team-members/types/TeamRole"
import { ParseKeys } from "i18next"

export interface ProjectRoleChipProps extends WithClassName {
  teamRole: TeamRole | null | undefined
  isLoading?: boolean
}

export const ProjectRoleChip = React.memo(
  ({ teamRole, isLoading, className }: ProjectRoleChipProps) => {
    const { t } = useTranslation()

    if (!teamRole && !isLoading) {
      return null
    }

    return (
      <Chip
        className={classNames("chip--small", "project-role-chip", className)}
        isLoading={isLoading}
      >
        {t(`Team.Role.${teamRole}` as ParseKeys) as string}
      </Chip>
    )
  }
)
